import axios from "axios";
import {
  GET_COUNTS,
  GET_ERROR,
  INCOME_LOADING,
  INCOME_REPORT,
  INCOME_ERROR,
} from "./types";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

// Only the newest income request may fill the dashboard, so a slow answer for an
// earlier period does not replace the one the admin picked after it.
let latestIncome = 0;

const DAILY_FAILED = "Өдөр тутмын орлогыг татаж чадсангүй";

// The day by day income of a range, as { report } or { error }. It is refused for a
// range longer than it shows, and a backend from before it answers with the admin's
// index.html and a 200. Neither may take the dashboard's totals with it. expired:
// the token is no longer valid.
const dailyOf = ({ startDate, endDate }) =>
  axios
    .get("/api/monitoring/income/daily", { params: { startDate, endDate } })
    .then((res) =>
      Array.isArray(res.data?.days) && Array.isArray(res.data?.kiosks)
        ? { report: res.data }
        : { error: DAILY_FAILED }
    )
    .catch((err) => ({
      error: err.response?.data?.errors?.[0]?.msg || DAILY_FAILED,
      expired:
        err.response?.status === 401 &&
        err.response.data?.msg === "Token is not valid",
    }));

//  The day by day income alone, for its own page (components/dashboard/DailyIncome.js):
//  { report } or { error }. Kept on the page, not in the store.
export const getDailyIncome = (range) => async (dispatch) => {
  const daily = await dailyOf(range);
  if (daily.expired) {
    window.localStorage.clear("x-auth-token");
    toastr.error("Session expired");
    dispatch(logout());
  }
  return daily;
};

//  Get user count
export const getCounts = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/monitoring/counts");
    dispatch({
      type: GET_COUNTS,
      payload: res.data,
    });
  } catch (err) {
    if (!err.response) {
      toastr.error("Үндсэн мэдээлэл татаж чадсангүй");
      return;
    }
    if (
      err.response.status === 401 &&
      err.response.data?.msg === "Token is not valid"
    ) {
      window.localStorage.clear("x-auth-token");
      toastr.error("Session expired");
      dispatch(logout());
    }
    const errors = err.response.data?.errors;
    if (errors) {
      errors.forEach((error) => toastr.error(error.msg));
    }
  }
};

//  Get printer income for a range, day by day too, and for the period before it
export const getIncome = (range) => async (dispatch) => {
  const request = ++latestIncome;
  dispatch({ type: INCOME_LOADING });
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const incomeOf = ({ startDate, endDate }) =>
      axios.post("/api/monitoring/income", { startDate, endDate }, config);
    const previousRange = range.previous || range;
    const [income, previous, daily] = await Promise.all([
      incomeOf(range),
      incomeOf(previousRange),
      dailyOf(range.daily || range),
    ]);
    if (request !== latestIncome) return;
    dispatch({
      type: INCOME_REPORT,
      payload: {
        income: income.data,
        previous: previous.data,
        daily,
        range,
        updatedAt: new Date(),
      },
    });
  } catch (err) {
    if (request !== latestIncome) return;
    dispatch({ type: INCOME_ERROR });
    // No response: the network or the server is down. The next refresh tries again.
    if (!err.response) {
      toastr.error("Орлогын мэдээлэл татаж чадсангүй");
      return;
    }
    if (
      err.response.status === 401 &&
      err.response.data.msg === "Token is not valid"
    ) {
      window.localStorage.clear("x-auth-token");
      toastr.error("Session expired");
      dispatch(logout());
    }
    const errors = err.response.data?.errors;
    if (errors) {
      errors.forEach((error) => toastr.error(error.msg));
    }
  }
};
